import { callApi } from '../utils';

// Per-service settings, behind the same Section/Subject/Group facade as the
// global settings page. Everything goes through callApi so writes pick up the
// global approval-required / 2fa-required interceptors.
//
// Setting keys contain colons (SERVICE:ABUJA:MAINTENANCE_MESSAGE,
// ABUJA_GATEWAY:PREPAID, APIX:IKEJA_GATEWAY), so any key used in a path segment
// has to be encoded.

// Structure only — no values. meta carries { total, service }.
export const getMenu = (serviceId) =>
  callApi(`/services/${serviceId}/settings`);

export const getSubject = (serviceId, section, subject) =>
  callApi(
    `/services/${serviceId}/settings/sections/${encodeURIComponent(
      section
    )}/subjects/${encodeURIComponent(subject)}`
  );

// Save-all, scoped to the subject — the same write mode the global page uses.
// A 400 rejects the whole batch; the 200 body carries the re-read subject.
export const saveSubject = (serviceId, section, subject, changes) =>
  callApi(
    `/services/${serviceId}/settings/sections/${encodeURIComponent(
      section
    )}/subjects/${encodeURIComponent(subject)}`,
    { data: changes },
    'patch'
  );

// Single-key access, kept for submit-on-change callers.
export const getItem = (serviceId, key) =>
  callApi(`/services/${serviceId}/settings/${encodeURIComponent(key)}`);

export const updateItem = (serviceId, key, value) =>
  callApi(
    `/services/${serviceId}/settings/${encodeURIComponent(key)}`,
    { value },
    'patch'
  );

export default { getMenu, getSubject, saveSubject, getItem, updateItem };
